"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var context_1 = require("../../context");
var Modal_1 = require("../Modal");
var Modal_2 = require("../Modal/Modal");
var Spinner_1 = require("../Spinner");
var ClientProfile_1 = __importDefault(require("./ClientProfile"));
function ClientProfileModal(props) {
    var trans = context_1.useSemantics().trans;
    var children = props.children, client = props.client, processing = props.processing, modalHandler = props.modalHandler, onDestroyed = props.onDestroyed, onEditClick = props.onEditClick, tabs = props.tabs, onOpen = props.onOpen, isLoadingTabs = props.isLoadingTabs, appendTabs = props.appendTabs;
    react_1.useEffect(function () {
        if (modalHandler.isModalOpen) {
            if (onOpen)
                onOpen();
        }
    }, [modalHandler.isModalOpen]);
    return (react_1.default.createElement(Modal_1.Modal, { size: Modal_2.ModalSize.LARGE, open: modalHandler.isModalOpen, onClose: modalHandler.closeModal, onDestroyed: function () { return onDestroyed && onDestroyed(client); } }, processing ? (react_1.default.createElement(Spinner_1.CenteredSpinner, { message: trans('optiiva::labels.loading') })) : (react_1.default.createElement(react_1.default.Fragment, null, client && (react_1.default.createElement(ClientProfile_1.default, { onEditClick: function (e) { return onEditClick(e, client); }, client: client, tabs: tabs, isLoadingTabs: isLoadingTabs, appendTabs: appendTabs }, children))))));
}
exports.default = ClientProfileModal;
//# sourceMappingURL=ClientProfileModal.js.map